module.exports = __webpack_public_path__ + "static/media/kakao.1ef27fed.svg";